import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotificationSystemComponent } from './notification-system.component';
import { UserMasterComponent } from './components/user-master/user-master.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]   
})
export class NotificationSystemRoutingModule {}
